/**
chart-union-area-legend
*/


<template>
    <div class="stats-mpa-legend">
        <table>
            <tr>
                <td><div style="background-color:rgba(124, 184, 84, 1)"></div></td>
                <td>Area in an MPA and protected by a byelaw restricting bottom towed fishing gear</td>
            </tr>
            <tr>
                <td><div style="background-color:rgba(242, 183, 1, 1)"></div></td>
                <td>Area in an MPA but not protected by a byelaw restricting bottom towed fishing gear</td>
            </tr>
            <tr>
                <td><div style="background-color:rgba(48, 93, 158, 1)"></div></td>
                <td>Area not in an MPA but protected by a byelaw restricting bottom towed fishing gear</td>
            </tr>
            <tr>
                <td><div style="background-color:rgba(194, 195, 196, 1)"></div></td>
                <td>Area not in an MPA or protected by a byelaw restricting bottom towed fishing gear</td>
            </tr>
        </table>
    </div>
</template>


<script>
    export default {
        name: "chart-union-area-legend",
        components: {},
        props: {},
        data: function () {
            return {}
        },
        methods: {},
        computed: {},
        watch: {},
        mounted: function () {
        }
    }
</script>


<style lang="scss">
//@import "../../styles/variables.scss";
    .stats-mpa-legend {
        margin-top: 20px;
        font-size: 70%;
        width: 100%;
        background-color: white;

        div {
            width: 15px; height: 15px;
            margin-right: 5px;
        }
    }
</style>